import { faChevronLeft, faCrown, faFire, faGraduationCap, faPlay, faAward } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {ReactComponent as ExcitedParrot} from '../../../../assets/images/Parrot_excited_1.svg'
import useFetch from "../../../../hooks/use-fetch";
import { getLangCode } from "../../../Helpers/Util/User";

const Learning = ({setActiveSection,locale}) => {
    const {t: translate } = useTranslation();
    const {apiUrl} = window['appConfig']
    const {data: learnData, error: learningError, initFunc: fetchUserLearning} = useFetch();
    const {data: locData, error: locationError, initFunc: fetchLocationData} = useFetch();
    const [isLoading, setIsLoading] = useState(true);
    const fetchOptions = {
        method: 'GET',
    };
    const userProfileArchives = localStorage.getItem('glup') ? JSON.parse(localStorage.getItem('glup')) : {};
    const [learningData, setLearningData] = useState({})
    const [locationData, setLocationData] = useState({})
    
    useEffect(() => {
        if( userProfileArchives && Object.prototype.hasOwnProperty.call(userProfileArchives, 'learn') && Object.prototype.hasOwnProperty.call(userProfileArchives, 'loc') ) {
            setLearningData(userProfileArchives.learn)
            setLocationData(userProfileArchives.loc)
            setIsLoading(false);
        } else {
            setIsLoading(true);
            fetchUserLearning({url:`${apiUrl}/progress/profile/summary`, options: fetchOptions})
            fetchLocationData({url:`${apiUrl}/progress/town`, options: fetchOptions})
        }
    }, [])

    useEffect(() => {
        if( learnData && locData) {
            setLearningData(learnData)
            setLocationData(locData)
            setIsLoading(false);
            userProfileArchives.learn = learnData;
            userProfileArchives.loc = locData;
            localStorage.setItem('glup', JSON.stringify(userProfileArchives));
        }
    }, [learnData, locData])

    if( isLoading ) {
        return <div className={`user-dashboard user-dashboard__inner`}>
            <div className="user-dashboard__header">
                <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                <h4 className="user-dashboard__title">{translate('my-learning-journey')}</h4>
            </div>
            <p className="user-dashboard__loading"></p>
        </div>
    }

    if( learningError ) {
        return (
            <div className={`user-dashboard user-dashboard__inner`}>
                <div className="user-dashboard__header">
                    <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                    <h4 className="user-dashboard__title">{translate('learnt-fragments')}</h4>
                    <div className="dashboard-section">
                        <h4 className="dashboard-section__title">{translate('error-has-occured')}</h4>
                        <div className="error-container">
                            <details  className="error-report" style={{ whiteSpace: 'pre-wrap' }}>{learningError}</details>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    
    if( locationError ) {
        return (
            <div className={`user-dashboard user-dashboard__inner`}>
                <div className="user-dashboard__header">
                    <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                    <h4 className="user-dashboard__title">{translate('learnt-fragments')}</h4>
                    <div className="dashboard-section">
                        <h4 className="dashboard-section__title">{translate('error-has-occured')}</h4>
                        <div className="error-container">
                            <details  className="error-report" style={{ whiteSpace: 'pre-wrap' }}>{locationError}</details>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    let lesson1Percentage = ((learningData?.lessonsNumbersCompleted[1] / learningData.totalLessonsCompleted) * 100).toFixed(0)
    let lesson2Percentage = ((learningData?.lessonsNumbersCompleted[2] / learningData.totalLessonsCompleted) * 100).toFixed(0)
    let lesson3Percentage = ((learningData?.lessonsNumbersCompleted[3] / learningData.totalLessonsCompleted) * 100).toFixed(0)
    let locations = locationData?.locations;

    let parrotMessage = translate('xp-start')
    
    if( learningData.xpPercentile > 0 && learningData.xpPercentile < 50 ) {
        parrotMessage = translate('xp-under-50');
    }
    
    if( learningData.xpPercentile > 50 ) {
        let percentage = 100 - learningData.xpPercentile <= 0 ? 1 : 100 - learningData.xpPercentile;
        parrotMessage = translate('xp-percentile', {percentage:percentage});
    }

    return (
        <div className={`user-dashboard user-dashboard__inner`}>
            <div className="user-dashboard__header">
                <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                <h4 className="user-dashboard__title">{translate('my-learning-journey')}</h4>
            </div>
            <div className="dashboard-section">
                <h4 className="dashboard-section__title">{translate('pollywood-learning-journey')}</h4>
                <div className="dashboard-section__two-cols">
                    <div className="dashboard-section__column">
                        <div className="bg-icon-block user-xp">
                            <FontAwesomeIcon icon={faCrown} size="2x" className="bg-icon-block__icon"/>
                            <h2 className="bg-icon-block__title">
                                <span>{new Intl.NumberFormat(getLangCode(locale), { maximumSignificantDigits: 3 }).format(learningData.totalXp)}</span>
                                {translate('experience-points')}
                            </h2>
                            
                            <div className="parrot">
                                <ExcitedParrot />
                                <div className="parrot__speech">{parrotMessage}</div>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard-section__column">
                        <div className="dashboard-section__row">
                            <div className="bg-icon-block current-streak">
                                <FontAwesomeIcon icon={faFire} size="2x" className="bg-icon-block__icon"/>
                                <h2 className="bg-icon-block__title">
                                    {translate('current-streak')}
                                    <span>{learningData.currentStreak}</span>
                                </h2>
                            </div>
                            <div className="bg-icon-block cefr-level coming-soon">
                                <FontAwesomeIcon icon={faGraduationCap} size="2x" className="bg-icon-block__icon"/>
                                <h2 className="bg-icon-block__title">
                                    {translate('cefr-level')}
                                    <span>{learningData.cefrLevel}</span>
                                </h2>
                            </div>
                        </div>
                        <div className="dashboard-section__row">
                            <div className="bg-icon-block completed-lessons">
                                <FontAwesomeIcon icon={faPlay} size="2x" className="bg-icon-block__icon"/>
                                <h2 className="bg-icon-block__title">
                                    {translate('completed-lessons')}
                                    <span>{learningData.totalLessonsCompleted}</span>
                                </h2>
                            </div>
                            <div className="bg-icon-block perfect-lessons">
                                <FontAwesomeIcon icon={faAward} size="2x" className="bg-icon-block__icon"/>
                                <h2 className="bg-icon-block__title">
                                    {translate('perfect-lessons')}
                                    <span>{learningData.perfectLessons}</span>
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <h4 className="dashboard-section__title">{translate('lesson-stats')}</h4>
                <p>{translate('lesson-stats-blurb')}</p>
                <div className="lesson-percentages">
                    <div className="lesson-percentages__legend">
                        <div className="legend">
                            <span className="legend__colour lesson-1"></span>
                            <span className="legend__title"> {translate('lesson-1')}</span>
                        </div>
                        <div className="legend">
                            <span className="legend__colour lesson-2"></span>
                            <span className="legend__title"> {translate('lesson-2')}</span>
                        </div>
                        <div className="legend">
                            <span className="legend__colour lesson-3"></span>
                            <span className="legend__title"> {translate('lesson-3')}</span>
                        </div>
                    </div>

                    <div className="lesson-percentages__track">
                        <span className="track__number">10</span>
                        <span className="track__number">20</span>
                        <span className="track__number">30</span>
                        <span className="track__number">40</span>
                        <span className="track__number">50</span>
                        <span className="track__number">60</span>
                        <span className="track__number">70</span>
                        <span className="track__number">80</span>
                        <span className="track__number">90</span>
                        <span className="track__number">100</span>
                    </div>
                    <div className="lesson-percentages__container">
                        <div className="lesson-percentage lesson-1" style={{width: `${lesson1Percentage}%`}}></div>
                        <div className="lesson-percentage lesson-2" style={{width: `${lesson2Percentage}%`}}></div>
                        <div className="lesson-percentage lesson-3" style={{width: `${lesson3Percentage}%`}}></div>
                    </div>
                </div>
            </div>
            <div className="dashboard-section">
                <h4 className="dashboard-section__title">{translate('visited-locations')}</h4>
                <div className="location-cards">
                    {Object.keys(locations).map((location, index) => {
                        let locationName = location;
                        let locationPercentage = locations[location].percent;
                        let buttonTitle = locationPercentage === 100 ? translate('retry') : translate('continue');

                        if(locations[location].started === false) return null;

                        return(
                            <div className="location-card" key={index}>
                                <div className="location-card__info">
                                    <span className="location-card__title">{locationName}</span>
                                    <div className="location-card__percent-bar">
                                        <div className="percent-bar" style={{width: `${locationPercentage}%`}}></div>
                                    </div>
                                </div>
                                <Link to={`/conversation/${locationName.toLowerCase()}`} className="button">{buttonTitle}</Link>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Learning